import type { Palette } from '@mui/material';
import type { TypographyOptions } from '@mui/material/styles/createTypography';

import { body } from '@constants/fonts';

export enum FontWeight {
  ExtraLight = 200,
  Light = 300,
  Regular = 400,
  Medium = 500,
  SemiBold = 600,
  Bold = 700,
  ExtraBold = 800,
  Black = 900,
}

const typography: (palette: Palette) => TypographyOptions = (palette) => {
  return {
    fontFamily: body,
    fontSize: 13,
    caption: {
      color: palette.grey['600'],
      fontSize: 12,
      lineHeight: '100%',
      fontWeight: FontWeight.Regular,
    },
    overline: {
      color: palette.text.primary,
      fontSize: 12,
      lineHeight: '250%',
      fontWeight: FontWeight.SemiBold,
      textTransform: 'uppercase',
    },
    body1: {
      color: palette.text.primary,
      fontSize: 16,
      lineHeight: '150%',
      fontWeight: FontWeight.Regular,
    },
    body2: {
      color: palette.text.secondary,
      fontSize: 14,
      lineHeight: '157%',
      fontWeight: FontWeight.Regular,
    },
    subtitle1: {
      color: palette.text.primary,
      fontSize: 16,
      lineHeight: '175%',
      fontWeight: FontWeight.Medium,
    },
    subtitle2: {
      color: palette.text.secondary,
      fontSize: 14,
      lineHeight: '157%',
      fontWeight: FontWeight.Medium,
    },
    h1: {
      color: palette.text.primary,
      fontSize: 56,
      lineHeight: '137.5%',
      fontWeight: FontWeight.Bold,
    },
    h2: {
      color: palette.text.primary,
      fontSize: 48,
      lineHeight: '137.5%',
      fontWeight: FontWeight.Bold,
    },
    h3: {
      color: palette.text.primary,
      fontSize: 36,
      lineHeight: '137.5%',
      fontWeight: FontWeight.SemiBold,
    },
    h4: {
      color: palette.text.primary,
      fontSize: 32,
      lineHeight: '137.5%',
      fontWeight: FontWeight.Bold,
    },
    h5: {
      color: palette.text.primary,
      fontSize: 24,
      lineHeight: '137.5%',
      fontWeight: FontWeight.Regular,
    },
    h6: {
      color: palette.text.primary,
      fontSize: 18,
      lineHeight: '137.5%',
      fontWeight: FontWeight.Regular,
    },
  };
};

export { typography };
